import { LotteryConfigModel } from "../models/lottery-configuration-model";
import { Lottery } from "../../../models/lottery";

export const sportkaConfig: LotteryConfigModel = {
    lottery: Lottery.sportka,
    boardCount: 8,
    primaryBoardSize: 6,
    defaultStake: 0,
    defaultStakeKasa: 3000,
    primaryNumbers: 49,
    boardLabel: "Sloupec",

    primarySystemMinCount: 7,
    primarySystemMaxCount: 15,
    primarySystemDefaultCount: 8,

    addonBoardSize: 6,
    addonNumbers: 9,

    basePrice: 30,
    addonPrice: 30,

    secondaryBoardSize: 0,
    secondaryNumbers: 0,

    hasDurationComponent: true,
    hasDrawOptions: true,
    hasMultidrawNotification: true,
    hasAllOrOneMultidrawOptions: true,
    hasSubscription: true,
    isDrawnEveryDay: true,
    durationTitle: "Sportka se hraje pravidelně 3x týdně. Mimořádně také jiné dny.",
    durationTitleShort: "Sportka se hraje pravidelně 3x týdně.",
    maxDuration: 36,

    multidrawDurationOptions: [
        { value: "wed", valueKasa: "WEDNESDAY", mainText: "Středa", dayOfWeek: 3, hour: 19, drawName: "wed" },
        { value: "fri", valueKasa: "FRIDAY", mainText: "Pátek", dayOfWeek: 5, hour: 19, drawName: "fri" },
        { value: "sun", valueKasa: "SUNDAY", mainText: "Neděle", dayOfWeek: 0, hour: 19, drawName: "sun" },
    ],
    hasCalculatedJackpot: false,
};
